import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import cls from "./combo-box.module.scss";
import classNames from "classnames";
import { CheckBox } from "../react-input/CheckBox";
export const SEPERATOR = Symbol("Seperator");
export const ADD_NEW = Symbol("AddNew");
export const NO_RECORD = Symbol("No-Record");
export const NULL_VALUE = Symbol("No-Value");
export const SEPERATOR_HEIGHT = 11;
export const renderItemFn = (props) => {
    const { valueField, textField, item } = props;
    const text = typeof textField === "function" ? textField(item) : item[textField];
    return _jsx("div", { className: cls.renderItem, children: _jsx("span", { className: "ellipsis", children: text }) }, item[valueField]);
};
export const multiSelectRenderItemFn = (props) => {
    const { textField, item, isSelected } = props;
    const text = typeof textField === "function" ? textField(item) : item[textField];
    return _jsxs(_Fragment, { children: [_jsx("div", { className: classNames(cls.center, cls["w-2em"]), children: _jsx(CheckBox, { tabIndex: -1, className: classNames(cls["font-1_3rem"]), checked: isSelected, readOnly: true }) }), _jsx("div", { style: { minWidth: 0 }, className: cls.flexFill, children: _jsx("div", { className: "ellipsis", children: text }) })] });
};
export function includes(text, search) {
    if (!text || !search)
        return true;
    // eslint-disable-next-line no-useless-escape
    const regex = new RegExp(search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), "i");
    return text.match(regex);
}
